import {useFormik} from 'formik'
import {Stream, useStream} from 'organization/Event/Management/StreamProvider'
import {useOrganizationEvent} from 'organization/Event/OrganizationEventProvider'
import React from 'react'
import {toast} from 'react-toastify'
import styled from 'styled-components'
import {useI18n} from 'i18n/I18nContext'

export function StreamManagement() {
  const {t} = useI18n()
  const {stream, updateStream, loading, startStream, stopStream} = useStream()

  const {event} = useOrganizationEvent()

  const {handleSubmit, handleBlur, handleChange, values} = useFormik({
    initialValues: {
      stream_url: stream?.stream_url ?? '',
      stream_key: stream?.stream_key ?? '',
    },
    onSubmit: async (values: Stream) => {
      const result = await updateStream(values)

      if (result === true) {
        toast.success(t('settings.saved'))
      }
    },
  })

  const isActive = event?.is_live
  const hasLiveStreamData = values.stream_url && values.stream_key

  const handleStartStream = async () => {
    const result = await startStream()

    if (result === true) {
      toast.success(t('orgStream.toastLiveStarted'))
    }
  }

  const handleStopStream = async () => {
    const result = await stopStream()

    if (result === true) {
      toast.success(t('orgStream.toastLiveStopped'))
    }
  }

  return (
    <StyledFormHolder>
      {' '}
      <form onSubmit={handleSubmit}>
        <div className="create__input-wrapper">
          <p>
            <b>{t('orgStream.title')} </b>
            <br />
            <i>
              <small>{t('orgStream.intro')}</small>
            </i>
            <br />
          </p>

          <div className="singel__input-field mb-15">
            <label className="input__field-text">
              {t('orgStream.urlLabel')} <br />
            </label>

            <input
              type="text"
              name="stream_url"
              disabled={loading || !isActive}
              placeholder={t('orgStream.urlPh')}
              defaultValue={values.stream_url}
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </div>

          <div className="singel__input-field mb-15">
            <label className="input__field-text">
              {t('orgStream.keyLabel')} <br />
            </label>

            <input
              type="text"
              name="stream_key"
              disabled={loading || !isActive}
              placeholder={t('orgStream.keyPh')}
              defaultValue={values.stream_key}
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </div>
          {!isActive && (
            <>
              <br />
              <center>
                <i>{t('orgStream.dayOnly')}</i>
              </center>
            </>
          )}

          <button
            type="submit"
            disabled={loading || !isActive}
            className={
              loading || !isActive
                ? 'disableBtnStyle w-100 mt-30'
                : 'input__btn w-100 mt-30'
            }
          >
            {t('orgStream.save')}
          </button>

          <ControllButtons>
            <StartButton
              type="button"
              onClick={handleStartStream}
              disabled={loading || !isActive || !hasLiveStreamData}
              className={
                loading || !isActive || !hasLiveStreamData
                  ? 'disableBtnStyle w-100 mt-30'
                  : 'input__btn w-100 mt-30'
              }
            >
              {t('orgStream.start')}
            </StartButton>

            <StopButton
              type="button"
              onClick={handleStopStream}
              disabled={loading || !isActive || !hasLiveStreamData}
              className={
                loading || !isActive || !hasLiveStreamData
                  ? 'disableBtnStyle w-100 mt-30'
                  : 'input__btn w-100 mt-30'
              }
            >
              {t('orgStream.stop')}
            </StopButton>
          </ControllButtons>
        </div>
      </form>
    </StyledFormHolder>
  )
}

const StyledFormHolder = styled.div`
  border: 1px solid #f7426f;
  border-radius: 5px;
  background-color: var(--clr-bg-pink);
  padding: 15px;
  margin-top: 50px;
`
const ControllButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  width: 100%;
  margin-top: 15px;
`

const StartButton = styled.button`
  flex: 1;
  background: linear-gradient(90deg, #05a95c, #05a95c);

  &.disableBtnStyle {
    background: #2e353a;
  }

  font-weight: 600;
  text-transform: uppercase;

  &::before {
    content: '';
    display: block;
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 11px solid currentColor;
  }
`

const StopButton = styled.button`
  flex: 1;
  text-transform: uppercase;
  background: linear-gradient(90deg, #d92027, #d92027);
  &.disableBtnStyle {
    background: #2e353a;
  }

  &::before {
    content: '';
    display: block;
    width: 11px;
    height: 11px;
    background-color: currentColor;
    border-radius: 1.5px; /* Slight rounding for a polished look */
  }
`
